import { Dispatch } from "redux"
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getDocuments = (page?: number, limit?: number, search: string = "") => async (dispatch: Dispatch) => {
    dispatch({ type: 'DOCUMENT_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/document/getAll/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'DOCUMENT_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_NOT_LOADING'
        })
    }
}

export const getDocumentsByEmployee = (page?: number, limit?: number, search: string = "", employee?: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'DOCUMENT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/document/getByEmployee/' + employee, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'DOCUMENT_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_NOT_LOADING'
        })
    }
}

export const addMultipleDocuments = (documentData: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({
            type: 'DOCUMENT_LOADING'
        })
        if (documentData.files !== null && documentData.files !== undefined && documentData.files !== '' && typeof documentData.files !== 'string') {
            let formData = new FormData()
            documentData?.files?.forEach((file: any) => {
                formData.append('files', file)
            })

            const { data } = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadfiles', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: sessionStorage.getItem('jwt')
                }
            })
            documentData.files = data
        }

        const { data, status } = await Axios.post('/api/document/registerMultiple', documentData, {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'DOCUMENT_ADD_MULTIPLE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_NOT_LOADING'
        })
    }
}

export const deleteMultiple = (documents: any) => async (dispatch: Dispatch) => {
    try {
        const { data, status } = await Axios.put('/api/document/deleteMultiple', { documents }, {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'DOCUMENT_DELETE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_ERROR'
        })
    }
}

export const deleteDocument = (document: string) => async (dispatch: Dispatch) => {
    dispatch({
        type: 'DOCUMENT_LOADING'
    })
    try {
        const { data, status } = await Axios.delete('/api/document/delete/' + document, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'DOCUMENT_DELETE_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DOCUMENT_NOT_LOADING'
        })
    }
}